import React from "react"

import Modal from "react-modal"
import { css } from "emotion"
import { withTheme } from "emotion-theming"
import Button from "./Button"

/**
 * ! COLOURS NEED CHANGING
 */

class StackerModal extends React.Component {
    render() {
        return (
            <Modal
                {...this.props}
                appElement={document.body}
                style={{
                    content: {
                        background: "#012",
                    },
                    overlay: {
                        background: "rgba(0, 0, 0, 0.75)",
                        zIndex: 2,
                    },
                }}
            >
                {this.props.children}
                <div>
                    <Button onClick={this.props.onRequestClose}>Close</Button>
                </div>
            </Modal>
        )
    }
}
export default withTheme(StackerModal)



// WEBPACK FOOTER //
// ./src/ui/components/Modal.js